const product = (productID) => ({
    urlParams: "",
    swatchesJSON: null,
    swatchesArray: null,
    currentProduct: null,
    currentProductJSON: null,
    currentColorLabel: null,
    currentFlavourProductBadge: '',
    productVariants: null,
    selectedVariant: null,
    selectedVariantID: null,
    selectedSellingPlanName: false,
    productAccordionsItems: null,
    productInfoItemsContainer: null,
    productReviewsStarsContainer: null,
    pairingProductsContainer: null,
    selectedPlan: '0',
    hasSellingPlan: false,
    sellingPlanId: null,
    selectedVariantSaleAllocationPrice: null,
    bundleSelection: 'single',
    selectedFreeProductVariantId: null,
    selectedFreeProductVariantTitle: null,
    variantDropdownIsOpen: false,
    stickyVariantDropdownIsOpen: false,
    modalIsOpen: false,
    disabledVariantsArray: null,
    reviewsStarsContainer: null,
    variantsInventoryJSON: null,
    variantsInventoryArray: null,
    currentProductVariantsInventoryQuantity: null,
    selectedVariantInventoryQuantity: null,
    showStickyButton:false,
    stickyVariantsDropdownOpen: false,
    stickySellingPlansDropdownIsOpen: false,
    apparelImagesContainer: null,
    subscriptionContainer: null,
    backInStockCountDownContainer: null,
    showSubscriptionModal: false,
    sellingPlanContent: null,
    selectedVariantSellingPlansIds: [],
    currentProductSellingPlansBestValue: null,
    subscriptionSettings: null,
    variantBadges: {},
    init() {
        const inStockContainer = document.querySelector('[data-form-container]')
            || document.querySelector('.starter-kit-subscription-widget__wrapper')
         this.subscriptionContainer = document.querySelector('.custom-subscription-widget__container-js');
        this.$nextTick(
            ()=> {
                Alpine.store("cart").freeProductId = this.selectedFreeProductVariantId
            }
        )

        this.urlParams = new URL(window.location.href)
        this.productAccordionsItems = document.querySelectorAll(".product-accordions")
        this.backInStockCountDownContainer = document.querySelector(".back-in-stock-countdown__container")
        this.productGallery = document.querySelector(".product-gallery")

        if (document.querySelector("[data-selling-content-json]")){
            this.sellingPlanContent = JSON.parse(document.querySelector("[data-selling-content-json]").innerHTML)["content"]
        }

        if (document.querySelector("[data-swatches]")){
            this.swatchesJSON = document.querySelector("[data-swatches]").innerHTML
            this.swatchesArray = JSON.parse(this.swatchesJSON).swatches
        }
        if (document.querySelector("[data-color-labels]")){
            this.colorLabelsJSON = document.querySelector("[data-color-labels]").innerHTML
            this.colorLabelsArray = JSON.parse(this.colorLabelsJSON)?.colorLabels
        }
        this.variantsInventoryJSON = document.querySelector("[data-inventory-values]").innerHTML
        this.variantsInventoryArray = JSON.parse(this.variantsInventoryJSON).inventoryQuantity

        this.currentProductJSON = document.querySelector("[data-current-product]").innerHTML

        if (document.querySelector("[data-subscription-settings]")) {
            this.subscriptionSettings = JSON.parse(document.querySelector("[data-subscription-settings]").innerHTML)
        }

        this.getCurrentProduct(productID)
        this.updateVariantBadges()
        this.getProductVariants()
        this.getCurrentColorLabel()
        this.getCurrentFlavourProductBadge()
        const urlVariantId = parseInt(this.urlParams.searchParams.get('variant'))
        const urlVariantBelongsToProduct = urlVariantId && this.currentProduct?.variants?.some(v => v.id === urlVariantId)
        this.selectedVariantID = urlVariantBelongsToProduct ? urlVariantId : this.currentProduct.variants[0].id

        this.getSelectedVariant(this.selectedVariantID)
        

        setTimeout(() => {
            this.updateRadioButtonStates()
            // Ensure free product visibility is set after DOM is ready
            this.updateFreeProductVisibility(this.selectedVariantID)
        }, 200)
        this.showStickyButton = this.isElementInViewport(inStockContainer);

        window.addEventListener('scroll', (event)=>{
            const container = document.querySelector('[data-form-container]')
                || document.querySelector('.starter-kit-subscription-widget__wrapper')
            if(container){
                this.showStickyButton = this.isElementInViewport(container);
            }
        })

        this.disableDisabledVariants()

        if (this.currentProduct){
            this.currentProduct.selling_plan_groups

            this.currentProductSellingPlansBestValue = this.currentProduct.selling_plan_groups[0].selling_plans.reduce((max, current) => {
                const currentMax = Math.max(...current.price_adjustments.map(adj => adj.value));
                const maxValue = max ? Math.max(...max.price_adjustments.map(adj => adj.value)) : -Infinity;

                return currentMax > maxValue ? current : max;
            }, null);
        }
    },
    getVariantContent(){
        const variantContentElement = document.querySelector("[data-variant-content]")
        if (variantContentElement && variantContentElement.innerHTML) {
            this.variantContentJSON = variantContentElement.innerHTML
            this.variantContentArray = JSON.parse(this.variantContentJSON).variants_content
        } else {
            this.variantContentArray = []
        }
    },

    disableDisabledVariants() {
        
        const disabledVariantsJSON = document.querySelector("[data-disabled-variants]")?.innerHTML;

        if (!disabledVariantsJSON) return;
        
        const disabledVariantsArray = JSON.parse(disabledVariantsJSON).disabled_variants

        if (!this.productVariants || !disabledVariantsArray || !disabledVariantsArray.length) return;

        this.productVariants.forEach(variant => {
            const disabledVariant = disabledVariantsArray.find(item => item[variant.id]);
            if (disabledVariant && disabledVariant[variant.id].is_disabled) {
                variant.is_disabled = true;
            }   
        })
    
    },
    scroolToProductForm(){
        const yOffset = -209; 
        const DistanseFromTop = this.subscriptionContainer?.getBoundingClientRect().top + window.scrollY + yOffset;
       window.scrollTo({top: DistanseFromTop, behavior: 'smooth'});
    },
    getCurrentProduct(id) {
        if (this.swatchesArray) {
            this.currentProduct = this.swatchesArray.filter(swatch => swatch.id === id)[0] || JSON.parse(this.currentProductJSON).currentProduct
        }else {
            this.currentProduct = JSON.parse(this.currentProductJSON).currentProduct
        }
    },
    getCurrentColorLabel(){
        const currentColor = this?.colorLabelsArray?.find(item => item?.product_id == this?.currentProduct.id)
        this.currentColorLabel = currentColor?.color_label || '';
    },
    getCurrentFlavourProductBadge() {
        const badge = this.currentProduct?.psn_flavour_product_badge
        this.currentFlavourProductBadge =
            badge != null && String(badge).trim() !== '' ? String(badge).trim() : ''
    },
    getDiscountedPrice(variantPrice, shopifyAllocationPrice) {
        // If settings discount applies, calculate settings-based price and use the lower one
        // subscriptionDiscount is a decimal percentage (e.g. 30.33 = 30.33%)
        if (this.subscriptionSettings && this.subscriptionSettings.appliesSettingsDiscount) {
            const discount = Number(this.subscriptionSettings.subscriptionDiscount) || 0;
            if (discount > 0) {
                const settingsPrice = Math.round(variantPrice * (1 - discount / 100));
                // Return the lower price (better deal for customer)
                return Math.min(shopifyAllocationPrice, settingsPrice);
            }
        }
        // Otherwise, use Shopify's pre-calculated price
        return shopifyAllocationPrice;
    },
    getSelectedVariant(id) {
        this.selectedVariantSellingPlansIds = []
        this.getVariantContent()
        if (this.productVariants) {
            this.selectedVariant = this.productVariants.filter(variant => variant.id == id)[0]
            this.selectedVariantID = id
            this.drawURL()
        }

        if (this.variantContentArray && this.variantContentArray.length){
            const foundItem = this.variantContentArray.find(item => item[id])
            this.selectedVariantContent = foundItem ? foundItem[id]["content"] : null
            this.selectedVariantSubscriptionInfo = foundItem ? foundItem[id]["subscription_info"] : null
        } else {
            this.selectedVariantContent = null
        }

        if (this.variantsInventoryArray && this.variantsInventoryArray.length){
            const inventoryItem = this.variantsInventoryArray.filter(item => item[this.currentProduct.id])[0]
            if (inventoryItem && inventoryItem[this.currentProduct.id]) {
                this.currentProductVariantsInventoryQuantity = inventoryItem[this.currentProduct.id].variant_invetory
                if (this.currentProductVariantsInventoryQuantity) {
                    const selectedInventory = this.currentProductVariantsInventoryQuantity.filter(item => item[id])[0]
                    this.selectedVariantInventoryQuantity = selectedInventory ? selectedInventory[id] : 0
                }
            }
        }


        if (this.selectedVariant?.selling_plan_allocations?.length > 0) {
            this.sellingPlanId = this.selectedVariant.selling_plan_allocations[0].selling_plan_id
        }

        if (this.selectedVariant?.selling_plan_allocations && this.selectedVariant.selling_plan_allocations.find(item => item.selling_plan_id == this.sellingPlanId)) {
            const shopifyAllocationPrice = this.selectedVariant.selling_plan_allocations.find(item => item.selling_plan_id == this.sellingPlanId).price
            this.selectedVariantSaleAllocationPrice = this.getDiscountedPrice(this.selectedVariant.price, shopifyAllocationPrice)
            if (this.currentProduct?.selling_plan_groups && this.currentProduct?.selling_plan_groups[0] && this.currentProduct?.selling_plan_groups[0].selling_plans) {
                const sellingPlan = this.currentProduct?.selling_plan_groups[0].selling_plans.filter(plan => plan.id === +this.sellingPlanId)[0]
                this.selectedSellingPlanName = sellingPlan ? sellingPlan.name : ''
            }
            this.hasSellingPlan = true
        } else if (this.selectedVariant) {
            this.selectedVariantSaleAllocationPrice = this.selectedVariant.price
            this.hasSellingPlan = false
        }

        this.stickyVariantDropdownIsOpen = false
        
        // Show/hide variant-level free products based on selected variant
        this.updateFreeProductVisibility(id)
        
        this.$nextTick(() => {
            this.updateRadioButtonStates()
        })

        if (this.selectedVariant){
            this.selectedVariantSellingPlansIds = this.selectedVariant.selling_plan_allocations.map(plan => plan.selling_plan_id)
            
            if (this.selectedPlan && this.selectedPlan !== '0') {
                const planExists = this.currentProduct?.selling_plan_groups?.[0]?.selling_plans.find(p => p.id == this.selectedPlan);
                const planHasContent = this.sellingPlanContent?.find(c => c.selling_plan_id == this.selectedPlan);
                const planAvailableForVariant = this.selectedVariantSellingPlansIds.includes(parseInt(this.selectedPlan));
                
                if (!planExists || !planHasContent || !planAvailableForVariant) {
                    if (this.selectedVariantSellingPlansIds.length > 0) {
                        this.selectedPlan = this.selectedVariantSellingPlansIds[0];
                        this.sellingPlanId = this.selectedVariantSellingPlansIds[0];
                    } else {
                        // Variant doesn't have subscription, switch to one-time
                        this.selectedPlan = '0';
                        this.sellingPlanId = null;
                        this.selectedVariantSaleAllocationPrice = this.selectedVariant.price;
                        this.hasSellingPlan = false;
                        this.selectedSellingPlanName = '';
                    }
                }
            } else if (this.selectedPlan === '0' && this.selectedVariantSellingPlansIds.length > 0) {
                // When switching from a variant without subscription to one with subscription,
                // automatically select the first subscription plan
                const firstPlanId = this.selectedVariantSellingPlansIds[0];
                const planExists = this.currentProduct?.selling_plan_groups?.[0]?.selling_plans.find(p => p.id == firstPlanId);
                const planHasContent = this.sellingPlanContent?.find(c => c.selling_plan_id == firstPlanId);
                
                if (planExists && planHasContent) {
                    this.selectedPlan = firstPlanId;
                    this.sellingPlanId = firstPlanId;
                    // Update the allocation price for the selected subscription plan
                    const shopifyAllocationPrice = this.selectedVariant?.selling_plan_allocations.find(item => item.selling_plan_id == firstPlanId)?.price;
                    if (shopifyAllocationPrice) {
                        this.selectedVariantSaleAllocationPrice = this.getDiscountedPrice(this.selectedVariant.price, shopifyAllocationPrice);
                        this.hasSellingPlan = true;
                        if (this.currentProduct?.selling_plan_groups && this.currentProduct?.selling_plan_groups[0] && this.currentProduct?.selling_plan_groups[0].selling_plans) {
                            const sellingPlan = this.currentProduct?.selling_plan_groups[0].selling_plans.filter(plan => plan.id === +firstPlanId)[0];
                            this.selectedSellingPlanName = sellingPlan ? sellingPlan.name : '';
                        }
                    }
                }
            } else if (this.selectedPlan !== '0' && this.selectedVariantSellingPlansIds.length === 0) {
                // When switching from a variant with subscription to one without subscription,
                // switch to one-time
                this.selectedPlan = '0';
                this.sellingPlanId = null;
                this.selectedVariantSaleAllocationPrice = this.selectedVariant.price;
                this.hasSellingPlan = false;
                this.selectedSellingPlanName = '';
            }
        }
    },
    updateFreeProductVisibility(variantId) {
        // Hide all variant-level free products
        const allFreeProductVariants = document.querySelectorAll('.free-product-variant')
        allFreeProductVariants.forEach(element => {
            element.classList.add('ps-hidden')
        })
        
        // Show the free product for the selected variant if it exists
        const selectedVariantFreeProduct = document.querySelector(`.free-product-variant[data-variant-id="${variantId}"]`)
        if (selectedVariantFreeProduct) {
            selectedVariantFreeProduct.classList.remove('ps-hidden')
        }
    },
    updateRadioButtonStates() {
        const radioButtons = document.querySelectorAll('.product-options__radio')
        radioButtons.forEach(radio => {
            const variantId = parseInt(radio.value)
            const isSelected = (variantId === parseInt(this.selectedVariantID))
            radio.checked = isSelected
        })
    },
    getProductVariants() {
        if (this.currentProduct) {
            this.productVariants = this.currentProduct.variants
            this.disableDisabledVariants()
        }
    },
    updateVariantBadges() {
        this.variantBadges = {}
        if (this.currentProduct && this.currentProduct.variant_badges) {
            this.currentProduct.variant_badges.forEach(item => {
                if (item && item.id && item.badge) {
                    this.variantBadges[item.id] = item.badge
                }
            })
        }
    },
    getSwatchStyle(swatch) {
        const colours = swatch.multi_colours;
        if (colours && colours.length >= 2) {
            const step = 360 / colours.length;
            const stops = colours.map((c, i) => {
                const start = i === 0 ? 0 : i * step - 0.5;
                const end = (i + 1) * step;
                return `${c} ${start}deg ${end}deg`;
            }).join(', ');
            return {
                background: `conic-gradient(from 0deg, ${stops})`,
                'mask-image': 'radial-gradient(white, black)',
                '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
            };
        }
        const single = (colours && colours[0]) || swatch.flavour_product_button_color || '#f5f5f5';
        return { backgroundColor: single };
    },
    switchSwatch(id, sectionId) {
        if (this.swatchesArray) {
            const previousOptionValues = this.selectedVariant?.options ? [...this.selectedVariant.options] : null
            this.currentProduct = this.swatchesArray.filter(swatch => swatch.id === id)[0]
            this.updateVariantBadges()
            this.getCurrentColorLabel()
            this.getCurrentFlavourProductBadge()
            this.getProductVariants()
            let targetVariant = this.currentProduct.variants[0]
            if (previousOptionValues?.length && this.currentProduct.variants?.length) {
                const matchingAvailable = this.currentProduct.variants.find(v =>
                    v.options?.length === previousOptionValues.length &&
                    v.options.every((opt, i) => opt === previousOptionValues[i]) &&
                    v.available
                )
                const matchingAny = this.currentProduct.variants.find(v =>
                    v.options?.length === previousOptionValues.length &&
                    v.options.every((opt, i) => opt === previousOptionValues[i])
                )
                targetVariant = matchingAvailable || matchingAny || targetVariant
            }
            this.selectedVariant = targetVariant
            this.selectedVariantID = targetVariant.id
            this.getSelectedVariant(this.selectedVariantID)
            history.pushState({}, '', this.currentProduct.handle);

            this.fetchProductData(this.currentProduct.handle, sectionId).then()
            this.drawURL()

            if (this.variantsInventoryArray && this.variantsInventoryArray.length){
                const inventoryItem = this.variantsInventoryArray.filter(item => item[id])[0]
                if (inventoryItem && inventoryItem[id]) {
                    this.currentProductVariantsInventoryQuantity = inventoryItem[id].variant_invetory
                    if (this.currentProductVariantsInventoryQuantity) {
                        const selectedInventory = this.currentProductVariantsInventoryQuantity.filter(item => item[this.selectedVariant.id])[0]
                        this.selectedVariantInventoryQuantity = selectedInventory ? selectedInventory[this.selectedVariant.id] : 0
                    }
                }
            }
            this.initBizPopup(this.currentProduct.handle)
    
        }
    },
    initBizPopup(productHandle){
        [...document.querySelectorAll('#BIS_frame')].forEach(el => {el?.remove()})
        
            fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
            window._BISConfig = window._BISConfig || {};
            _BISConfig.product = product;
            }).then(() => {
                BIS?.init();
                
            })
    },
    drawURL() {
        if (this.selectedVariant) {
            this.urlParams = new URL(window.location)
            this.urlParams.searchParams.set('variant', this.selectedVariantID);
            history.replaceState(this.selectedVariantID, "variant", this.urlParams)
        }
    },
    async fetchProductData(handle, sectionId) {
        await fetch(`${window.location.pathname}?section_id=${sectionId}`)
            .then(res => res.text())
            .then(data => this.reRenderProductComponents(data))
            .then(()=> {
                this.reinitYotpoWidgets()
                requestAnimationFrame(() => {
                    this.getVariantContent()
                    this.getSelectedVariant(this.selectedVariantID)
                    this.updateRadioButtonStates()
                })
            })
    },  
    reRenderProductComponents(data){
        this.productInfoItemsContainer = document.querySelector(".product-info-items")
        this.productReviewsStarsContainer = document.querySelector(".product-reviews-stars")
        this.pairingProductsContainer = document.querySelector(".pairing-products-container")
        this.reviewsStarsContainer = document.querySelector(".reviews-stars-container")
        this.apparelImagesContainer = document.querySelector(".apparel-images-gallery")
        this.subscriptionWidgetWrapper = document.querySelector(".custom-subscription-widget__wrapper")

        const parsed = new DOMParser().parseFromString(data, 'text/html')

        const swatchesJSON = parsed.querySelector("[data-swatches]")
        const parsedAccordionsItems = parsed.querySelectorAll(".product-accordions")
        const parsedProductInfoItems = parsed.querySelector(".product-info-items")
        const pairingProductsContainer = parsed.querySelector(".pairing-products-container")
        const reviewsStarsContainer = parsed.querySelector(".reviews-stars-container")
        const apparelImagesGallery = parsed.querySelector(".apparel-images-gallery")
        const apparelImagesJSON = parsed.querySelector("[data-apparel-images]")
        const backInStockCountDownContainer = parsed.querySelector(".back-in-stock-countdown__container")
        const productGallery = parsed.querySelector(".product-gallery")
        const parsedVariantContent = parsed.querySelector("[data-variant-content]")

        if (productGallery){
            this.productGallery.innerHTML = productGallery.innerHTML
            
            // Reinitialize Alpine.js productGallery component
            this.$nextTick(() => {
                this.reinitProductGallery()
            })
        }

        if (backInStockCountDownContainer){
            this.backInStockCountDownContainer.innerHTML = backInStockCountDownContainer.innerHTML
        }

        if (this.apparelImagesContainer){
            if (apparelImagesJSON){
                this.apparelImagesContainer.innerHTML = apparelImagesGallery.innerHTML
            }else{
                this.apparelImagesContainer.innerHTML = ""
            }
        }

        if (this.reviewsStarsContainer){
            this.reviewsStarsContainer.innerHTML = reviewsStarsContainer.innerHTML
            // Update data-yotpo-product-id after re-render
            const yotpoWidgets = this.reviewsStarsContainer.querySelectorAll('[data-yotpo-product-id]')
            yotpoWidgets.forEach(widget => {
                widget.setAttribute('data-yotpo-product-id', this.currentProduct.id)
            })
        }

        const parsedKitWidget = parsed.querySelector(".starter-kit-subscription-widget__wrapper")
        const localKitWidget = document.querySelector(".starter-kit-subscription-widget__wrapper")
        const parsedSubWidget = parsed.querySelector(".custom-subscription-widget__wrapper")
        const localSubWidget = document.querySelector(".custom-subscription-widget__wrapper")

        const localWidget = localKitWidget || localSubWidget
        const parsedWidget = parsedKitWidget || parsedSubWidget

        if (localWidget && parsedWidget) {
            if (localKitWidget && parsedKitWidget) {
                // kit → kit: replaceWith so Alpine destroys old component and re-instantiates
                // x-data with the new flavour's config (sellingPlanId, prices, onetime product)
                localKitWidget.replaceWith(parsedKitWidget)
            } else if (localSubWidget && parsedSubWidget) {
                // sub → sub: innerHTML swap (no own x-data, parent product Alpine bound)
                localSubWidget.innerHTML = parsedSubWidget.innerHTML
            } else {
                // cross-type (kit ↔ sub): the two wrappers live at different DOM levels —
                // sub wrapper is nested inside <form> (add_to_cart_button block), kit wrapper
                // is a top-level starter_kit_subscription block. Surgical replaceWith would
                // orphan the wrapper without its required parent structure (broken ATC, missing
                // form, mismatched surrounding blocks). Cleanest path: full page reload —
                // pushState already updated the URL, so reload() lands on the new product's
                // properly-templated full PDP.
                window.location.reload()
                return
            }
        }
        
        // Also update widgets in product-reviews-stars container
        const productReviewsStarsContainer = document.querySelector('.product-reviews-stars')
        if (productReviewsStarsContainer) {
            const productReviewsWidgets = productReviewsStarsContainer.querySelectorAll('[data-yotpo-product-id]')
            productReviewsWidgets.forEach(widget => {
                widget.setAttribute('data-yotpo-product-id', this.currentProduct.id)
            })
        }

        this.swatchesJSON = document.querySelector("[data-swatches]")

        if (swatchesJSON && this.swatchesJSON){
            this.swatchesJSON.innerHTML = swatchesJSON.innerHTML
            this.swatchesArray = JSON.parse(this.swatchesJSON.innerHTML).swatches
        }

        if (this.pairingProductsContainer && pairingProductsContainer) {
            this.pairingProductsContainer.innerHTML = pairingProductsContainer.innerHTML
            // Update data-yotpo-product-id for pairing products
            const pairingYotpoWidgets = this.pairingProductsContainer.querySelectorAll('[data-yotpo-product-id]')
            pairingYotpoWidgets.forEach(widget => {
                // For pairing products use current product ID
                widget.setAttribute('data-yotpo-product-id', this.currentProduct.id)
            })
        }

        if (this.productInfoItemsContainer && parsedProductInfoItems) {
            this.productInfoItemsContainer.innerHTML = parsedProductInfoItems.innerHTML
        }else if (this.productInfoItemsContainer) {
            this.productInfoItemsContainer.innerHTML = ''
        }

        this.productAccordionsItems.forEach((accordionItem, index) => {
            accordionItem.innerHTML = parsedAccordionsItems[index].innerHTML
        })

        const variantContentElement = document.querySelector("[data-variant-content]")
        if (variantContentElement && parsedVariantContent) {
            variantContentElement.innerHTML = parsedVariantContent.innerHTML
        }

        const parsedSubtitle = parsed.querySelector('[data-product-subtitle]')
        const localSubtitle = document.querySelector('[data-product-subtitle]')
        if (localSubtitle && parsedSubtitle) {
            localSubtitle.textContent = parsedSubtitle.textContent
        }

        const parsedRichtextBlocks = parsed.querySelectorAll('[data-pdp-richtext]')
        const localRichtextBlocks = document.querySelectorAll('[data-pdp-richtext]')
        localRichtextBlocks.forEach((block, i) => {
            if (parsedRichtextBlocks[i]) {
                block.innerHTML = parsedRichtextBlocks[i].innerHTML
            }
        })
    },
    getPlanPriceForVariant(variantId, planId) {
        const variant = this.currentProduct?.variants?.find(v => v.id == variantId);
        if (!variant) return 0;
        const allocation = variant.selling_plan_allocations?.find(a => a.selling_plan_id == planId);
        if (!allocation) return variant.price;
        return this.getDiscountedPrice(variant.price, allocation.price);
    },
    changeSellingPlan(event, freeProductId){
        this.selectedPlan = event.target.getAttribute("data-selling-plan-id")
        this.sellingPlanId = event.target.value
        if (this.selectedVariant.selling_plan_allocations.find(item => item.selling_plan_id == this.sellingPlanId)){
            const shopifyAllocationPrice = this.selectedVariant.selling_plan_allocations.find(item => item.selling_plan_id == this.sellingPlanId).price
            this.selectedVariantSaleAllocationPrice = this.getDiscountedPrice(this.selectedVariant.price, shopifyAllocationPrice)
            if (this.currentProduct.selling_plan_groups && this.currentProduct.selling_plan_groups[0] && this.currentProduct.selling_plan_groups[0].selling_plans) {
                const sellingPlan = this.currentProduct.selling_plan_groups[0].selling_plans.filter(plan => plan.id === +this.sellingPlanId)[0]
                this.selectedSellingPlanName = sellingPlan ? sellingPlan.name : ''
            }
            this.stickySellingPlansDropdownIsOpen = false
        }
        window.setTimeout(() => {
            if (freeProductId){
                Alpine.store("cart").freeProductId = freeProductId
            }
        }, 600)
    },
    switchSubscription(event, freeProductId){
        this.scroolToProductForm()
        this.selectedPlan = event.target.getAttribute("data-selling-plan-id")
        window.setTimeout(() => {

            Alpine.store("cart").freeProductId = freeProductId
        }, 600)
    },
    selectFreeProductVariant(event){
        this.selectedFreeProductVariantId = event.target.value
        this.selectedFreeProductVariantTitle = event.target.getAttribute("data-variant-title")
        Alpine.store("cart").freeProductId = this.selectedFreeProductVariantId
        this.variantDropdownIsOpen = false
        this.stickyVariantDropdownIsOpen = false
    },
    toggleVariantDropDown(){
        this.variantDropdownIsOpen = !this.variantDropdownIsOpen
    },
    toggleStickyVariantDropDown(){
        this.stickyVariantDropdownIsOpen = !this.stickyVariantDropdownIsOpen
    },
    toggleStickySellingPlansDropdown(){
        this.stickySellingPlansDropdownIsOpen = !this.stickySellingPlansDropdownIsOpen
    },
    backInStockSubmit(event) {
        let closestForm = event.target.closest('form');
        let emailInput = closestForm.querySelector('.product-card__notify-input');
        let emailValue = emailInput.value;
        let variant_id = closestForm.querySelector('.bis-variant-id').value;
        let shopify_variant_id = '$shopify:::$default:::' + variant_id;
        const bis_options = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2023-08-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL'],
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: emailValue,
                                }
                            },
                            email: emailValue,
                        }
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: shopify_variant_id
                            }
                        }
                    }
                }
            })
        };

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UhGMFT', bis_options)
            .then(response => {
                if(response.status === 202) {
                    closestForm.querySelector('.bis-success').classList.remove('ps-hidden');
                    emailInput.value = '';
                }
            })
            .catch(err => console.error(err));
    },
    toggleNotifyMeModal(){
        this.modalIsOpen = !this.modalIsOpen
        document.body.classList.toggle("ps-overflow-hidden")
    },
    isElementInViewport(el) {
        const rect = el?.getBoundingClientRect();
        return (
            rect && rect.top + el.clientHeight < 0
        );
    },
    reinitProductGallery() {
        if (this.productGallery) {
            const productGalleryComponent = Alpine.$data(this.productGallery)
            if (productGalleryComponent && typeof productGalleryComponent.reinitImageGallery === 'function') {
                productGalleryComponent.reinitImageGallery()
            }
        }
    },
    async swapGalleryToHandle(handle) {
        if (!handle) return false
        try {
            const res = await fetch(`/products/${handle}`)
            if (!res.ok) return false
            const html = await res.text()
            const parsed = new DOMParser().parseFromString(html, 'text/html')
            const remoteGallery = parsed.querySelector('.product-gallery')
            if (remoteGallery && this.productGallery) {
                this.productGallery.innerHTML = remoteGallery.innerHTML
                this.$nextTick(() => {
                    this.reinitProductGallery()
                })
                return true
            }
            return false
        } catch (err) {
            console.warn('[psn-product] swapGalleryToHandle failed', err)
            return false
        }
    },
    reinitYotpoWidgets() {
        setTimeout(() => {
            try {
                // Clean up existing Yotpo widgets
                const existingWidgets = document.querySelectorAll('.yotpo-widget-instance, .yotpo-widget')
                existingWidgets.forEach(widget => {
                    widget.innerHTML = ''
                    
                    const attributesToRemove = [
                        'data-yotpo-element-loaded',
                        'data-yotpo-widget-uuid',
                        'data-yotpo-name',
                        'data-yotpo-url',
                        'data-yotpo-price',
                        'data-yotpo-currency',
                        'data-yotpo-image-url',
                        'data-yotpo-description',
                        'data-yotpo-prevent-load-rs'
                    ]
                    
                    attributesToRemove.forEach(attr => {
                        if (widget.hasAttribute(attr)) {
                            widget.removeAttribute(attr)
                        }
                    })
                    
                    if (!widget.classList.contains('yotpo-widget-instance')) {
                        widget.classList.add('yotpo-widget-instance')
                    }
                })
                
                // Find all Yotpo widgets in document
                const allYotpoWidgets = document.querySelectorAll('[data-yotpo-product-id]')
                
                // Update widgets by class if no data-yotpo-product-id widgets found
                if (allYotpoWidgets.length === 0) {
                    const widgetInstances = document.querySelectorAll('.yotpo-widget-instance')
                    widgetInstances.forEach(widget => {
                        widget.setAttribute('data-yotpo-product-id', this.currentProduct.id)
                    })
                }
                
                // Update widgets in target containers or with matching product ID
                allYotpoWidgets.forEach(widget => {
                    const oldId = widget.getAttribute('data-yotpo-product-id')
                    const container = widget.closest('.reviews-stars-container, .pairing-products-container, .product-reviews-stars')
                    
                    if (container || oldId == this.currentProduct.id) {
                        widget.setAttribute('data-yotpo-product-id', this.currentProduct.id)
                    }
                })
                
                // Clear Yotpo cache
                if (window.yotpo && typeof window.yotpo.clearCache === 'function') {
                    window.yotpo?.clearCache()
                }
                
                // Reinitialize widgets
                if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
                    window.yotpoWidgetsContainer.initWidgets()
                }
                
                if (window.yotpo && typeof window.yotpo?.initWidgets === 'function') {
                    window.yotpo?.initWidgets()
                }
                
                if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
                    window.yotpo?.refreshWidgets()
                }
                
                // Force reinitialization for target widgets
                const targetWidgets = document.querySelectorAll(`[data-yotpo-product-id="${this.currentProduct.id}"]`)
                targetWidgets.forEach(widget => {
                    try {
                        if (window.yotpo?.initWidgets) {
                            window.yotpo?.initWidgets()
                        }
                    } catch (e) {
                        console.error('Error forcing widget reinitialization:', e)
                    }
                })
                
                // Additional reinitialization attempts
                setTimeout(() => {
                    let widgets = document.querySelectorAll('[data-yotpo-product-id]')
                    
                    if (widgets.length === 0) {
                        widgets = document.querySelectorAll('.yotpo-widget-instance')
                    }
                    
                    widgets.forEach(widget => {
                        const productId = widget.getAttribute('data-yotpo-product-id')
                        if (productId == this.currentProduct.id) {
                            const event = new Event('DOMContentLoaded', { bubbles: true })
                            widget.dispatchEvent(event)
                        }
                    })
                    
                    // Manual widget creation
                    if (window.yotpo && typeof window.yotpo.Widget === 'function') {
                        let allWidgetElements = document.querySelectorAll('[data-yotpo-product-id]')
                        
                        if (allWidgetElements.length === 0) {
                            allWidgetElements = document.querySelectorAll('.yotpo-widget-instance')
                        }
                        
                        allWidgetElements.forEach(widgetElement => {
                            const productId = widgetElement.getAttribute('data-yotpo-product-id')
                            if (productId == this.currentProduct.id) {
                                try {
                                    new window.yotpo.Widget({
                                        productId: this.currentProduct.id,
                                        element: widgetElement,
                                        instanceId: widgetElement.getAttribute('data-yotpo-instance-id') || '447234'
                                    })
                                } catch (e) {
                                    console.error('Error creating manual Yotpo widget:', e)
                                }
                            }
                        })
                    }
                    
                    // Final attempt
                    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
                        setTimeout(() => {
                            window.yotpo.initWidgets()
                        }, 100)
                    }
                }, 200)
                
                // Check if widgets loaded properly
                setTimeout(() => {
                    const loadedWidgets = document.querySelectorAll(`[data-yotpo-product-id="${this.currentProduct.id}"]`)
                    loadedWidgets.forEach(widget => {
                        const hasContent = widget.children.length > 0 || widget.innerHTML.trim() !== ''
                        
                        if (!hasContent) {
                            try {
                                if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
                                    window.yotpo.initWidgets()
                                }
                            } catch (e) {
                                console.error('Error reinitializing empty widget:', e)
                            }
                        }
                    })
                }, 1000)
            } catch (error) {
                console.error('Error reinitializing Yotpo widgets:', error)
            }
        }, 300)
    },
    toggleSubscriptionWidget(){
        this.showSubscriptionModal = !this.showSubscriptionModal
        document.body.style.overflow = this.showSubscriptionModal ? "hidden" : ""
        document.body.style.position = this.showSubscriptionModal ? "fixed" : ""
        document.body.style.maxHeight = this.showSubscriptionModal ? "100vh" : ""
    }
})

export default product

window.addEventListener("alpine:init", () => {
    Alpine.data("product", product)
})
